export default __webpack_public_path__ + "static/media/158.3d6ec9b2.jpg";